import React, { Component } from "react";
import { IconButton, Modal } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";

export default class CustomModal extends Component {

    constructor(props) {
        super(props);
        this.state = {  
            open: false,
            children: <></>,
            width: 'auto',
            height: 'auto'
        }
    }

    handleOpen = (children, width = 'auto', height = 'auto') => {
        this.setState({ open: true, children, width, height });
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    render() {

        return (
            <Modal
                open={this.state.open}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >   
                <div 
                    style={{
                        background: '#fff',
                        width: this.state.width,
                        height: this.state.height,
                        maxWidth: 900,
                        maxHeight: '95dvh',
                        borderRadius: 6,
                        margin: 15,
                        position: 'relative'
                    }}
                >
                    <IconButton style={{ position: 'absolute', top: 5, right: 5, zIndex: 99999999999999 }} onClick={ this.handleClose }>
                        <CloseOutlined fontSize="small" />
                    </IconButton>

                    {this.state.children}
                </div>
            </Modal>
        );
    }
}